<template>
<div style="width: 100%;"   >
  <div class="item-inner"  v-if="attribute.sorteditAble === false">
    <div class="item-title label" style="color: gray;font-size: .7rem">{{this.attribute.label}}</div>
    <div class="item-input" >
      <!--<input type="text" style="font-size: .6rem;text-align: right; "  value="点我选基因"  readonly unselectable="on">-->
    </div>
  </div>
  <div class="item-inner"  v-else>
    <div class="item-title label" style="color: gray;font-size: .7rem">{{this.attribute.label}}</div>
    <div class="item-input" v-if="merchandises.categoryId === 20" >
      <input type="text" style="font-size: .6rem;text-align: right;color: rgb(8, 148, 236) "  value="点我选基因/转录本"  class="open-popup open-goods" data-popup=".popup-gene-only" readonly unselectable="on">
    </div>
  </div>
  <!--<div class="item-inner" v-if="attribute.sorteditAble === false" >-->
    <!--<div class="item-title label" style="color: gray;font-size: .7rem">{{this.attribute.label}}</div>-->
    <!--<div class="item-input" >-->
      <!--<input type="text" style="font-size: .6rem;text-align: right; "  :value="attribute.valueText" placeholder="选基因" class="open-popup open-goods" data-popup=".popup-gene-only" readonly unselectable="on">-->
    <!--</div>-->
  <!--</div>-->
  <!--<div class="item-inner" v-else >-->
    <!--<div class="item-title label" style="color: gray;font-size: .7rem">{{this.attribute.label}}</div>-->
    <!--<div class="item-input" >-->
      <!--<input type="text" :value="attribute.valueText"  style="font-size: .6rem;text-align: right; "   readonly="readonly">-->
    <!--</div>-->
  <!--</div>-->
  <div class="item-inner specal" v-if="merchandises._attributes.ReguTech.value !== 4 && merchandises._attributes.ReguTech.value !== 3 && merchandises._attributes.ReguTech.value !== '4' && merchandises._attributes.ReguTech.value !== '3'">
    <div class="item-title label">基因名</div>
    <div class="item-input" v-if="merchandises.categoryId === 20">
      <input type="text" :value="attribute.value.symbol"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
    <div class="item-input" v-else>
      <input type="text" :value="attribute.value.symbol"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
  </div>
  <div class="item-inner specal" v-if="merchandises._attributes.ReguTech.value === 4 || merchandises._attributes.ReguTech.value === 3 ||  merchandises._attributes.ReguTech.value === '4'|| merchandises._attributes.ReguTech.value === '3'" >
    <div class="item-title label">microName</div>
    <div class="item-input" >
      <input type="text" :value="attribute.value.microName"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
  </div>
  <div class="item-inner specal" v-if="merchandises._attributes.ReguTech.value === 4 || merchandises._attributes.ReguTech.value === 3 || merchandises._attributes.ReguTech.value === '4' || merchandises._attributes.ReguTech.value === '3'" >
    <div class="item-title label">microNo</div>
    <div class="item-input" >
      <input type="text" :value="attribute.value.microNo"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
  </div>
  <div class="item-inner specal" v-if="merchandises._attributes.ReguTech.value !== 4 && merchandises._attributes.ReguTech.value !== 3 &&  merchandises._attributes.ReguTech.value !== '4' && merchandises._attributes.ReguTech.value !== '3'" >
    <div class="item-title label">基因大小</div>
    <div class="item-input" >
      <input type="text" :value="attribute.value.CDSSize"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
  </div>
  <div class="item-inner specal"  >
    <div class="item-title label">物种</div>
    <div class="item-input" v-if="attribute.value.taxName">
      <input type="text" :value="attribute.value.taxName"  style="font-size: .6rem;text-align: right; "   readonly="readonly">
    </div>
  </div>
  <div class="item-inner specal " v-if="merchandises._attributes.ReguTech.value !== 4 && merchandises._attributes.ReguTech.value !== 3 && merchandises._attributes.ReguTech.value !== '4' && merchandises._attributes.ReguTech.value !== '3'">
    <div class="item-title label" >转录本</div>
    <div class="item-input">
      <input type="text" :value="attribute.value.NMID"   style="font-size: .6rem;text-align: right; "  readonly="readonly">
    </div>
  </div>
  <!--<div class="item-inner">-->
    <!--<div class="item-title label" style="width: 60%;color: #8e8e93">物种</div>-->
    <!--<div class="item-input">-->
      <!--<input type="text" :value="curAttrsInGroup[9].valueText" readonly="readonly">-->
    <!--</div>-->
  <!--</div>-->
</div>
  <!--<div style="width: 100%;"  v-else="" >-->
    <!--<div class="item-inner"  >-->
      <!--<div class="item-title label" style="width: 60%;">{{this.attribute.label}}</div>-->
      <!--<div class="item-input" >-->
        <!--<input type="text" :value="attribute.valueText" placeholder="选基因" class="open-popup open-goods" data-popup=".popup-gene-only" readonly unselectable="on">-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="item-inner" >-->
      <!--<div class="item-title label" style="width: 60%">基因大小</div>-->
      <!--<div class="item-input">-->
        <!--<input type="text" :value="curAttrsInGroup[10].valueText" readonly="readonly">-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="item-inner">-->
      <!--<div class="item-title label" style="width: 60%;">转录本</div>-->
      <!--<div class="item-input">-->
        <!--<input type="text" :value="curAttrsInGroup[8].valueText" readonly="readonly">-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="item-inner">-->
      <!--<div class="item-title label" style="width: 60%;">物种</div>-->
      <!--<div class="item-input">-->
        <!--<input type="text" :value="curAttrsInGroup[9].valueText" readonly="readonly">-->
      <!--</div>-->
    <!--</div>-->
  <!--</div>-->

</template>

<script>
  import $ from 'jquery'
  import Emkt from '../../../emkt'
  import {mapState} from 'vuex'
  const REGUTECH_OVEREXPRESSION = 1
  const TOOLTYPE_LENTIVIRUS = 1
  const TOOLTYPE_PLASMID = 2
  const TOOLTYPE_ADENOVIRUS = 3
  const TOOLTYPE_RETROVIRUS = 5
  const TOOLTYPE_FLOATVIRUS = 6
  export default {
    name: 'finder-attr-gene-box',
    data () {
      return {
        attributevalueText: ''
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup', 'customAttrs', 'merchandises'
    ],
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      options () {
        if (this.attribute.options) {
          return this.attribute.options
        }
        return {}
      },
      attrOptions () {
        let attr = this.curAttrsInGroup
        let resList = []
        for (var i in attr) {
          if (attr[i].customizable === 0 && attr[i].columnName.indexOf('TVInfo.') < 0) {
            resList.push(attr[i])
          }
        }

        return resList
      },
      ...mapState([
        'geneSearchResult', 'hardGeneInfo'
      ])
    },
    methods: {
      fetchData () {
        console.log(1111)
        console.log(this.merchandises)
        if (typeof this.attribute.value === 'string' && this.attribute.value !== 'null' && this.attribute.value !== undefined) {
          if (this.attribute.value !== '' && JSON.parse(this.attribute.value) !== null) {
            let data1 = JSON.parse(this.attribute.value)
            let dictionary = Emkt.getEmktMetaData().dictionariesMap
            data1['taxName'] = dictionary[61033][data1.taxId].dictValue
            this.attribute.value = data1
            this.attribute.valueText = data1
          }
        }
        if (this.merchandises._attributes['GeneInfo.symbol'] && this.merchandises._attributes['GeneInfo.symbol'].value !== '') {
          if (this.attribute.value === '') {
            this.attribute.value = {}
            this.attribute.value.symbol = this.merchandises._attributes['GeneInfo.symbol'].value
          }
        }
        console.log(this.attribute)
        /*
        if (this.geneSearchResult['/custOrder']) {
          this.attributevalueText = this.geneSearchResult['/custOrder'].data.symbol
        } else {
          this.attributevalueText = this.attribute.value.symbol
        }
        */
      }
    },
    watch: {
      'geneSearchResult': function (val) {
        var _this = this
        let data = val['/finder/finderMerchandises'].data
        let dictionary = Emkt.getEmktMetaData().dictionariesMap
        data['taxName'] = dictionary[61033][data.taxId].dictValue
        var scpoe = dictionary[55006][_this.merchandises._attributes.GeneInfo_Category_Scope.value].dictValue
        console.log(data)
        console.log(dictionary[61064][data.category].dictValue)
        if (scpoe.indexOf(dictionary[61064][data.category].dictValue) !== -1) {
//          if (data.category === 4 && data.ttttflag === ) {
//
//          }
          if (_this.hardGeneInfo && _this.hardGeneInfo.length > 0) {
            var hardHeneGo = true
            console.log('hardGeneInfo', _this.hardGeneInfo)
            for (let hardGene of _this.hardGeneInfo) {
              if (hardGene.productGuid !== undefined && hardGene.productGuid) { // 合同小类拦截
                console.log(_this.merchandises)
                if (_this.merchandises.attributes.ProductGuid === hardGene.productGuid) {
                  if (hardGene.level === Emkt.HardGeneLevelNo1) {
                    hardHeneGo = false
                    break
                  } else {
                    if (hardGene.removeTLNo !== undefined && hardGene.removeTLNo) { // 有排除基因
                      if (_this.merchandises.attributes.TVInfo && !hardGene.removeTLNo.includes(_this.merchandises.attributes.TVInfo.TLNo)) {
                        hardHeneGo = false
                        break
                      }
                    } else {
                      hardHeneGo = false
                      break
                    }
                  }
                }
              } else { // 合同大类检查调控技术 和靶点设计方案
                if (_this.merchandises.attributes.Tech && hardGene.tech.includes(_this.merchandises.attributes.Tech)) {
                  if (hardGene.targetSupplier !== undefined && hardGene.targetSupplier) {
                    if (_this.merchandises.attributes.TargetSupplier !== undefined && _this.merchandises.attributes.TargetSupplier && hardGene.targetSupplier.includes(_this.merchandises.attributes.TargetSupplier)) {
                      if (hardGene.level === Emkt.HardGeneLevelNo1) {
                        hardHeneGo = false
                        break
                      } else {
                        if (hardGene.removeTLNo) { // 有排除基因
                          if (_this.merchandises.attributes.TVInfo && !hardGene.removeTLNo.includes(_this.merchandises.attributes.TVInfo.TLNo)) {
                            hardHeneGo = false
                            break
                          }
                        } else {
                          hardHeneGo = false
                          break
                        }
                      }
                    }
                  } else {
                    hardHeneGo = false
                    break
                  }
                }
              }
            }
            if (!hardHeneGo) {
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302')
              return
            }
          } else {
            if (data.riskWarning) {
              _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302')
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              return
              // this.$weui.confirm(val.hardGeneDescription, function () {
              //   setTimeout(function () {
              //   }, 300)
              // }, function () {
              //   setTimeout(function () {
              //       // 逻辑行1
              //     _this.attribute.value = ''
              //     _this.attribute.valueText = ''
              //     // 逻辑行2
              //   }, 300)
              // })
            }
          }
          console.log(_this.merchandises._attributes)
            // 质粒>10k 或 腺病毒>6.5k 或 慢病毒>6k 或 逆转录>4k 或 悬浮慢病毒>6k
          if (_this.merchandises._attributes.ReguTech.value === REGUTECH_OVEREXPRESSION) {
            if ((_this.merchandises._attributes.ToolType.value === TOOLTYPE_LENTIVIRUS && data.CDSSize > 6000) ||
                    (_this.merchandises._attributes.ToolType.value === TOOLTYPE_PLASMID && data.CDSSize > 10000) ||
                    (_this.merchandises._attributes.ToolType.value === TOOLTYPE_ADENOVIRUS && data.CDSSize > 6500) ||
                    (_this.merchandises._attributes.ToolType.value === TOOLTYPE_RETROVIRUS && data.CDSSize > 4000) ||
                    (_this.merchandises._attributes.ToolType.value === TOOLTYPE_FLOATVIRUS && data.CDSSize > 6000)) {
              console.log('基因太大不可构建！')
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              _this.$weui.alert('您好，您选择的基因暂时无法提供该产品，请选择其他产品或咨询客服，联系电话400-621-0302')
              return
            }
          }
          if (_this.merchandises._attributes.ReguTech.value === 1 && (_this.merchandises._attributes.ToolType.value === 1 || _this.merchandises._attributes.ToolType.value === 6 || _this.merchandises._attributes.ToolType.value === 7)) {
            if (data.CDSSize > 4000 && data.CDSSize < 6000) {
              $.modal({
                title: '请您核对',
                afterText: '<div>老师您选择的基因信息超过4K，公司不承诺滴度和总量，我司会尝试包装两次，按照实际滴度和总量发货,点击【确定】表示您认可我司的方案。您可以点击【返回修改】或者咨询在线客服。</div>',
                buttons: [
                  {
                    text: '返回修改',
                    bold: true,
                    onClick: function () {
                      _this.attribute.value = ''
                      _this.attribute.valueText = ''
                    }
                  },
                  {
                    text: '确定',
                    bold: true,
                    onClick: function () {
                      _this.attribute.value = data
                      _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
                      _this.$emit('controlForm', _this.index, _this.attribute)
                    }
                  }
                ]
              })
            } else if (data.CDSSize > 6000) {
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              alert('您选择的基因大小超过6K，暂时不支持在线订购。详细您可以咨询电话400-621-0302或者咨询在线客服。')
            } else {
              console.log(data)
              _this.attribute.value = data
              _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
              _this.$emit('controlForm', _this.index, _this.attribute)
            }
          } else if (_this.merchandises._attributes.ReguTech.value === 1 && _this.merchandises._attributes.ToolType.value === 4) {
            if (data.CDSSize > _this.merchandises._attributes.GeneSizeLimit.value) {
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              _this.$weui.alert('您选择的基因大小超过对应载体的包装容量，您可以返回上一步重新选择适用更大CDS基因的载体。同时您也可以电话400-621-0302或者咨询在线客服。')
            } else {
              _this.attribute.value = data
              _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
              _this.$emit('controlForm', _this.index, _this.attribute)
            }
          } else if (_this.merchandises._attributes.ReguTech.value === 1 && (_this.merchandises._attributes.ToolType.value === 3 || _this.merchandises._attributes.ToolType.value === 2)) {
            if (data.CDSSize > 6000) {
              _this.attribute.value = ''
              _this.attribute.valueText = ''
              _this.$weui.alert('您选择的基因大小超过6K，暂时不支持在线订购。详细您可以咨询电话400-621-0302或者咨询在线客服。')
            } else {
              _this.attribute.value = data
              _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
              _this.$emit('controlForm', _this.index, _this.attribute)
            }
          } else if (_this.merchandises._attributes.ReguTech.value === 2 && _this.merchandises._attributes.TargetSupplier.value === 2) {
            if (data.CDSSize > 4000) {
              $.modal({
                title: '请您核对',
                afterText: '<div>您选择的基因大小超过4K，我司对于基因大小超过4k的基因不承诺敲减效率。点击【确定】表示您接受认可此承诺条款，此承诺条款如和其他地方描述冲突，以该处承诺条款为准。您可以点击【返回修改】或者咨询在线客服。</div>',
                buttons: [
                  {
                    text: '返回修改',
                    bold: true,
                    onClick: function () {
                      _this.attribute.value = ''
                      _this.attribute.valueText = ''
                    }
                  },
                  {
                    text: '确定',
                    bold: true,
                    onClick: function () {
                      _this.attribute.value = data
                      _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
                      _this.$emit('controlForm', _this.index, _this.attribute)
                    }
                  }
                ]
              })
            } else {
              _this.attribute.value = data
              _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
              _this.$emit('controlForm', _this.index, _this.attribute)
            }
          } else if ((data.category === 2 || data.category === 3) && data.ttttflag === 1 && _this.merchandises._attributes.TVInfo.value.TTTTFlag === 0) {
            _this.attribute.value = ''
            _this.attribute.valueText = ''
            _this.$weui.alert('您选择的miRNA存在4个连续的T，使用U6启动子构建有提前转录终止的可能，建议您返回上一步重新选择启动子为Ubi，CMV等二型启动子的载体')
          } else {
            _this.attribute.value = data
            _this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
            _this.$emit('controlForm', _this.index, _this.attribute)
          }
        } else {
          _this.attribute.value = ''
          _this.attribute.valueText = ''
          var message = ''
          if (scpoe.indexOf('MicroUp') !== -1) {
            message = '您需要选择的基因类型为pre-miRNA，请重新选择。pre-miRNA的名称中不包含-3p或者-5p，同时编号由MI+数字组成。'
          } else if (scpoe.indexOf('MicroDown') !== -1) {
            message = '您需要选择的基因类型为mature miRNA，请重新选择。mature miRNA的名称通常包含-3p或者-5p，同时编号由MIMAT+数字组成。'
          } else {
            message = '您需要选择的基因类型为' + scpoe + '，请您重新选择！'
          }
          _this.$weui.alert(message)
        }
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }

  .specal {
    border-bottom: 0px solid;
  }
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .options {
    color: grey;
    font-size: .6rem;
    width: 120px;
    margin-left: .3rem;
  }

  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -2.5rem;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .button.active {
    z-index: 100;
    color: #00469A;
    background-color: white;
    border-bottom: 1px solid
  }
  .tab-link.button {
    border: 0px solid black;
    color: gray;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// FinderAttrGeneBox.vue?505f3dd9